<app-title-section></app-title-section>

<div class="card p-1" style="margin-left: 15px; margin-right: 15px; min-height:100vh;">
    <ul class="nav nav-tabs m-0" style="border-bottom: 1px solid #eee;">
        <li class="nav-item" *ngFor="let s of statuses">
            <a class="nav-link" [routerLink]="['/vente/avoir', s.path]" [class.active]="currentStatus === s.path" (click)="filterByStatus(s.path, s.status)">
                {{ s.label }} <span *ngIf="currentStatus === s.path">({{ getStatusCount(s.status) }})</span>
            </a>
        </li>
    </ul>
    <div class="container-fluid" style="padding: 0; width: 100%; max-width: 100%;">
        <router-outlet></router-outlet>
    </div>
</div>
